export default __webpack_public_path__ + "static/media/editar_black.8e3c875f.svg";